export function isCustomDomain(
  /** Check if passed domain is custom */
  domain?: string
) {
  const vocalOrigins = [
    import.meta.env.VITE_APP_WEBAPP_ORIGIN,
    'https://integrations.vocal.email',
    'https://vocal-teams-app.vercel.app'
  ]

  if (domain)
    return !vocalOrigins.includes(domain)

  const { value } = useState('is-custom-domain', () => {
    const url = useRequestURL()
    return !vocalOrigins.includes(url.origin)
  })

  return value
}
